import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError, AxiosResponse } from 'axios';
import { appAxios } from '@doda/common/src/libs/axios/appAxios';
import {
  ErrorResponseBody,
  PublicationPhotosResponse,
} from '@doda/api-client/aspida/@types';
import { IncomingHttpHeaders } from 'http';

// 企業公開写真一覧取得失敗時のエラーコード
export type GetCorporatePublishedPhotoErrorCode = 'NOT_FOUND';
export type CorporatePublishedPhotoError = ErrorResponseBody & {
  code: GetCorporatePublishedPhotoErrorCode | undefined;
};

/**
 * 企業公開写真一覧取得処理
 */
export const getCorporatePublishedPhotoUrlByJobId = createAsyncThunk<
  PublicationPhotosResponse,
  { jobId: string; headers?: IncomingHttpHeaders },
  {
    rejectValue: CorporatePublishedPhotoError | undefined;
  }
>('publicationPhoto/getByJobId', async (opt, thunkAPI) => {
  const { jobId, headers } = opt;
  const url = `/api/v1/corporateClients/publicationPhotos/job/${jobId}`;
  const publicationPhotosResponse = await appAxios({
    url,
    headers,
    params: {
      jobId,
    },
  })
    .then((res: AxiosResponse<PublicationPhotosResponse>) => {
      return res.data;
    })
    .catch((error: AxiosError<CorporatePublishedPhotoError>) => {
      return thunkAPI.rejectWithValue(error.response?.data);
    });

  return publicationPhotosResponse;
});

export type GetCorporatePublishedPhotoUrlByjobId = ReturnType<
  ReturnType<typeof getCorporatePublishedPhotoUrlByJobId>
>;
